import type { ReviewIssueType } from "./types";

const REVIEW_ISSUE_LABELS: Record<ReviewIssueType, string> = {
  direction_issue: "方向问题",
  method_issue: "方法问题",
  execution_issue: "执行问题",
  random_factor: "随机因素",
  insufficient_data: "数据不足",
};

export function reviewIssueLabel(issueType: ReviewIssueType | undefined): string {
  return issueType ? `${REVIEW_ISSUE_LABELS[issueType]}（${issueType}）` : "未分类";
}
